import React from "react";
import { Link } from "react-router-dom";
import { ArticleSummary } from "../types";
import AuthorInfo from "../authorInfo";

const ArticleCard = ({ article }: { article: ArticleSummary }) => {
  return (
    <Link to={`/articles/${article._id}`} className="article-card">
      <img
        src={article.defaultImage}
        alt={article.title}
        className="article-card-image"
      />
      {article.tags?.[0] ? (
        <span className="article-card-tag">{article.tags[0]}</span>
      ) : null}
      <h3 className="article-card-title">{article.title}</h3>
      <p className="article-card-description">{article.description}</p>
      <AuthorInfo author={article.createdBy} variant="compact" />
    </Link>
  );
};

export default ArticleCard;
